<template>
  <ul
    v-if="props.isOpenList"
    class="settings-item__list"
  >
    <AvalSentiment
      v-for="(item, i) in sentimentList"
      :key="i"
      :model-value="isSentimentSelected(item.value)"
      class="settings-item__list-item"
      :type="item.type"
      @click="toggleSentiment(item.value)"
    />
  </ul>
</template>

<script setup>
import {computed, defineProps} from "vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import {debounce} from "@/functions/debouncer";

const props = defineProps({
  isOpenList: {
    type: Boolean,
    default: false,
  }
});

const newsFeedStore = useNewsFeedStore();

const sentimentList = [
  {
    type: "neutral",
    value: 0
  },
  {
    type: "sad",
    value: -1
  },
  {
    type: "good",
    value: 1
  },
];

// Вычисляемая функция. Проверка выбран ли указанный сантимент
const isSentimentSelected = computed(() => {
  return (sentiment) => {
    return newsFeedStore.filterSentiment.list.includes(sentiment);
  };
});

// Функция переключения сантимента в фасете.
const toggleSentiment = async (sentiment) => {
  if (isSentimentSelected.value(sentiment)) {
    newsFeedStore.filterSentiment.list = newsFeedStore.filterSentiment.list.filter(icon => icon !== sentiment);
  } else {
    newsFeedStore.filterSentiment.list.push(sentiment);
  }
  await updateNewsDebounce();
};

// Функция. Обновление списка новостей
const updateNews = async () => {
  newsFeedStore.clearNewsFeed();
  await newsFeedStore.getNews();
};
const updateNewsDebounce = debounce(updateNews, 700);

</script>

<style lang="scss" scoped>
.settings-item {
  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
  }
}

</style>